import React from "react";
import Input from "../../../../common/Input";
import { getStockDetails, searchStocks } from "./service";
import {
  StockSelectorContainer,
  SearchResults,
  SearchResult,
  StockHeading,
  EditStock,
  NASDAQ,
  StockName,
  EditModeElements,
  CloseEditMode,
} from "./styles";
import CloseSVG from "../../../../../resources/close.svg";
import Loader from "../../../../common/Loader";
import colors from "../../../../../config/colors";
import { setStockInURL } from "./utils";
import { parseQuery } from "../../../../../utils/common";
import { defaultSelectedStock } from "./constants";
import Error from "../../../../common/Error";
import ReactGA from "react-ga";

function StockSelector({ selectedStock, setSelectedStock }) {
  let [editMode, setEditMode] = React.useState(false);
  let [currentSearch, setCurrentSearch] = React.useState("");
  let [stockDetails, setStockDetails] = React.useState(false);
  let [searchResults, setSearchResults] = React.useState([]);

  React.useEffect(() => {
    let params = parseQuery(window.location.search.slice(1));
    if (!params.ticker || params.ticker === "undefined") {
      setSelectedStock(defaultSelectedStock);
    } else {
      searchStocks(params.ticker).then((retrievedSearchResults) => {
        if (retrievedSearchResults.length > 0) {
          setSelectedStock(
            retrievedSearchResults.find(
              (result) => result.nasdaq === params.ticker
            ) || retrievedSearchResults[0]
          );
        }
      }).catch(e=>{
        if(e?.response?.data){
          setSearchResults(e.response.data.message || e.response.data.detail);
        }
        else{
          setSearchResults(e.message || "Failed to load sentiment data.");
        }
      });
    }
  }, [setSelectedStock]);

  React.useEffect(() => {
    if (currentSearch.length < 1) {
      setSearchResults([]);
    } else {
      searchStocks(currentSearch).then((retrievedSearchResults) => {
        setSearchResults(retrievedSearchResults);
      })
    }
  }, [currentSearch]);

  React.useEffect(() => {
    if (!selectedStock) {
      return;
    }
    getStockDetails(selectedStock).then(() => {
      setStockDetails(selectedStock);
      setStockInURL(selectedStock);
      setEditMode(false);
    });
  }, [selectedStock]);
  if(searchResults && typeof searchResults === "string"){
    return <StockSelectorContainer>
      <Error text={"Failed to load stock"}/>
    </StockSelectorContainer>
  }
  return (
    <StockSelectorContainer>
      {!editMode && !stockDetails && <Loader />}
      {!editMode && stockDetails && (
        <StockHeading>
          <NASDAQ>{stockDetails.nasdaq}</NASDAQ>
          <StockName>{stockDetails.name}</StockName>
        </StockHeading>
      )}
      {editMode && (
        <EditModeElements>
          <Input
            value={currentSearch}
            setValue={setCurrentSearch}
            width={"300px"}
          />{" "}
          <CloseEditMode src={CloseSVG} onClick={() => setEditMode(false)} />
        </EditModeElements>
      )}
      {editMode && (
        <SearchResults hideSuggestions={searchResults === 0}>
          {searchResults.map((result, index) => {
            return (
              <SearchResult
                key={index}
                onClick={() => {
                  ReactGA.event({
                    category: "App - Dashboard",
                    action: "Selected stock from Search Results",
                    label:result.nasdaq,
                  });
                  setSelectedStock(result);
                }}
              >
                <NASDAQ>{result.nasdaq}</NASDAQ>
                <StockName>{result.name}</StockName>
              </SearchResult>
            );
          })}
        </SearchResults>
      )}

      {!editMode && (
        <EditStock
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => {
            setEditMode(true);
          }}
        >
          <rect width="30" height="30" rx="15" fill={colors.darkBackground} />
          <path
            d="M13.2 5.6C8.79115 5.6 5.19995 9.1912 5.19995 13.6C5.19995 18.0088 8.79115 21.6 13.2 21.6C13.5215 21.6 13.8386 21.5808 14.1503 21.5436C16.7019 21.239 19.6419 21.1732 21.4589 22.9902L23.0343 24.5656C23.108 24.6424 23.1963 24.7037 23.294 24.7459C23.3917 24.7882 23.4969 24.8105 23.6033 24.8116C23.7098 24.8126 23.8153 24.7925 23.9139 24.7522C24.0124 24.712 24.1019 24.6525 24.1772 24.5773C24.2525 24.502 24.312 24.4125 24.3522 24.3139C24.3924 24.2154 24.4126 24.1098 24.4115 24.0034C24.4104 23.8969 24.3881 23.7918 24.3459 23.6941C24.3037 23.5964 24.2424 23.5081 24.1656 23.4344L22.5902 21.859C20.7731 20.0419 20.839 17.1019 21.1436 14.5504C21.1808 14.2387 21.2 13.9215 21.2 13.6C21.2 9.1912 17.6088 5.6 13.2 5.6ZM13.2 7.2C16.744 7.2 19.6 10.0559 19.6 13.6C19.6 17.1441 16.744 20 13.2 20C9.65585 20 6.79995 17.1441 6.79995 13.6C6.79995 10.0559 9.65585 7.2 13.2 7.2Z"
            fill={colors.darkPrimary}
          />
        </EditStock>
      )}
    </StockSelectorContainer>
  );
}
export default StockSelector;
